export default "__VITE_ASSET__Sb4jNJ$5__"